<template>
  <div class="FooterGreyLeft" role="contentinfo" :data-theme="this.$store.state.chosenBrand">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <h3 class="dealer-name">Auto Dealer</h3>
        </div>
      </div>
      <div class="footer-line-divide"></div>
      <div class="row">
        <div class="col-xs-12">
          <div class="FooterGreyLeftMenu">
            <li role="menuitem">
              <a href="#" target="" title="New">New</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Pre-Owned">Pre-Owned</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Specials">Specials</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Financing">Financing</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Service &amp; Parts">Service &amp; Parts</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="About">About</a>
            </li>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="footer-contact">
            <div class="footer-phones">
              <a class="sales-phone footer-phone" href="#">Sales: (919) 555-5555</a>
              <a class="service-phone footer-phone" href="#">Service: (919) 555-5555</a>
            </div>
            <div class="footer-address">
              <a alt="123 Main St, Raleigh, NC 27609" aria-label="address"
                href="#">123 Main St, Raleigh, NC 27609</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="footer-social">
            <a aria-label="Facebook" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-facebook"></i></a>
            <a aria-label="Instagram" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-instagram"></i></a>
            <a aria-label="Twitter" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-twitter"></i></a>
            <a aria-label="Yelp" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-yelp"></i></a>
          </div>
        </div>
      </div>
      <div class="footer-line-divide"></div>
      <div class="row footer-bottom">
        <div class="col-md-3 col-xs-12">
          <a href="#">
            <img alt="Sokal" class="footer-logos sokal-white-logo" 
              src="../../static/images/sokal-logo-white.png">
          </a>
          <span class="copyright"><a href="#">© </a>{{ new Date().getFullYear() }}</span>
        </div>
        <div class="col-md-9 col-xs-12 text-right">
          <div class="footer-site-links">
            <a class="toggle-sitemap" href="#">Site Map</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Accessibility Policy</a>
            <a href="#">Legal Disclaimer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
export default {
  computed: {
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.FooterGreyLeft {
  background: #101010;
  color: #fff;
  font-size: 15px;
  margin-top: 2px;
  padding-top: 4%;
  padding-bottom: 4%;
}
.FooterGreyLeft[data-theme="infiniti"] {
  background: var(--primary-color, #020B24);
}
.FooterGreyLeft a {
  text-decoration: none;
  text-transform: uppercase;
  color: #999;
  letter-spacing: 2px;
  -moz-transition: all 300ms ease-out;
  -webkit-transition: all 300ms ease-out;
  -o-transition: all 300ms ease-out;
  transition: all 300ms ease-out;
}
.FooterGreyLeft a:hover, .FooterGreyLeft a:focus, .FooterGreyLeft a:active {
  opacity: .7;
}
.FooterGreyLeftMenu {
  list-style: none;
  margin-bottom: 30px;
}
.FooterGreyLeftMenu li {
  display: inline-block;
  margin-bottom: 10px;
}
.FooterGreyLeftMenu a {
  color: #fff;
}
.FooterGreyLeft h3 {
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 24px;
  margin-bottom: 0px;
}
.FooterGreyLeft .footer-line-divide {
  height: 2px;
  width: 100%;
  background: #737373;
}
.FooterGreyLeft .footer-line-divide, .FooterGreyLeft .row {
  margin-top: 30px;
  margin-bottom: 30px;
}
.FooterGreyLeftMenu li:not(:last-child) {
  margin-right: 20px;
}
.FooterGreyLeft .footer-contact {
  margin-top: 30px;
}
.FooterGreyLeft .footer-contact .footer-phones a:not(:last-child) {
  padding-right: 15px;
  border-right: 1px solid #999;
  margin-right: 15px;
}
.FooterGreyLeft .footer-contact .footer-address {
  margin-top: 10px;
}
.FooterGreyLeft .footer-social a:not(:last-child) {
  margin-right: 15px;
}
.FooterGreyLeft .footer-social i {
  font-size: 24px;
}
.FooterGreyLeft .footer-bottom {
  font-size: 13px;
  margin-top: 45px;
}
.FooterGreyLeft .sokal-white-logo {
  height: 22px;
  margin: 0px 20px 0px 0px;
  opacity: .5;
}
.FooterGreyLeft .copyright {
  color: #999;
}
.FooterGreyLeft .footer-bottom .footer-site-links a:not(:last-child) {
  margin-right: 20px;
}

@media (max-width: 991px) {
  .FooterGreyLeft .footer-bottom .col-md-3 {
    margin-bottom: 20px;
  }
  .FooterGreyLeft .footer-bottom .text-right {
    text-align: left;
  }
}
@media (max-width: 767px) {
  .FooterGreyLeft .footer-contact .footer-address {
    display: block;
    margin-top: 15px;
  }
}
@media (max-width: 575px) {
  .FooterGreyLeft {
    font-size: 14px;
  }
  .FooterGreyLeft .footer-bottom .footer-site-links a {
    display: block;
    margin: 10px 0px;
  }
}
</style>
